module.exports = __webpack_public_path__ + "img/img_sub_ser_outsourcing01.c37cb494.svg";